package com.narbase.narnic.trial.common

import kotlinx.browser.window
import kotlin.js.Json

fun addCrossDocumentMessagingHandler() {
    window.addEventListener("message", {
        val dataString = it.asDynamic().data as? String ?: return@addEventListener
        runCatching { handleCrossDocumentMessaging(dataString) }
    })

}

private fun handleCrossDocumentMessaging(dataString: String) {
    val data = JSON.parse<Json>(dataString)
    when (data["message"]) {
        "formSubmitted" -> {
            window.location.href = "https://balsammedico.com/thank_you"
        }
    }
}
